import { useRemittances, useTransactions } from '@/hooksApi';
import { TransactionFilters } from '@/stores/useTransactionFilteringStore';
import { FinanceTab, RemittanceRecord } from '@/types';
import { formatDateByDayjs, getFilterTransactionQuery } from '@/utils';

const useRemittanceData = (
  current: number,
  activeTab: FinanceTab,
  pageSize?: number,
  language?: string,
  transactionFilter?: TransactionFilters,
  remittanceStatusFilter?: string,
  remittanceDateFrom?: string,
  remittanceDateTo?: string,
) => {
  const { data, isLoading, isFetching } = useRemittances(
    current,
    pageSize,
    activeTab === FinanceTab.COD || activeTab === FinanceTab.Balance,
    remittanceStatusFilter,
    remittanceDateFrom,
    remittanceDateTo,
  );
  const {
    data: dataTransactions,
    isLoading: loadingTransaction,
    isFetching: fetchingTransaction,
  } = useTransactions(
    current,
    pageSize,
    activeTab === FinanceTab.Transactions,
    language,
    getFilterTransactionQuery(transactionFilter),
  );

  const dataRemittance: RemittanceRecord[] =
    data?.object?.items?.map((remittance) => ({
      key: remittance?.uid,
      date: formatDateByDayjs(remittance.created_at, 'D MMMM YYYY'),
      remittanceId: remittance?.platform_code,
      amount: `${remittance?.amount}`,
      status: remittance?.status?.title,
      statusSlug: remittance?.status?.slug,
      payment_method: (remittance as any)?.payment_method ?? undefined,
      orders_count: (remittance as any)?.orders_count ?? undefined,
      paid_to: (remittance as any)?.paid_to ?? undefined,
    })) || [];

  const dataRemittanceTransactions =
    dataTransactions?.object?.items?.map((transaction) => ({
      key: transaction?.uid,
      date: formatDateByDayjs(transaction?.created_at, 'D MMMM YYYY'),
      transactionId: transaction?.platform_code || '---',
      orderId:
        transaction.item_platform_code && transaction.item_platform_code.startsWith('BXO')
          ? transaction.item_platform_code
          : '---',
      order_uid: transaction?.order_uid ?? null,
      order_platform_code: transaction?.order_platform_code ?? null,
      type: transaction?.type,
      title: transaction?.subject,
      amount: transaction?.amount,
      status: transaction?.status?.title,
      details: transaction?.details || '---',
      is_correction: transaction?.is_correction || 0,
    })) || [];

  // totals
  const totals = data?.object?.total || 0;
  const totalTransactions = dataTransactions?.object?.total || 0;

  return {
    dataRemittance,
    totals,
    totalTransactions,
    isLoading,
    loadingTransaction,
    isFetching,
    fetchingTransaction,
    dataRemittanceTransactions,
  };
};

export default useRemittanceData;
